import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicSecureDataShareListParamsRawI,
	type LWApiPublicSecureDataShareListResultRawI,
} from '@liquidweb-dev/club-sauce/public/secureDataShare/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SECURE_DATA_SHARE_LIST_QUERY_KEY = '/secureDataShare/list';

const useSecureDataShareList = (
	params: LWApiPublicSecureDataShareListParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicSecureDataShareListResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SECURE_DATA_SHARE_LIST_QUERY_KEY, params],
		queryFn: () => api.secureDataShare.apiRaw.list(params),
		...options,
	});

export default useSecureDataShareList;
